<div class="thank-you-group">
  <h1>Thank you</h1>
  <div class="thank-you-messages">
    <p>Thank you for getting in touch.</p>
    <p>Our team will reach out soon to discuss your needs further.</p>
  </div>
  <a class="submit-btn" [routerLink]="['/']">Back to homepage</a>
</div>
